import React, { useState } from "react";
import { Paper, Divider } from "@mui/material";
import OrderHeader from "./OrderHeader";
import OrderItemList from "./OrderItemList";
import OrderSummary from "./OrderSummary";
import OrderDetails from "./OrderDetails";
import OrderFooter from "./OrderFooter";

const OrderCard = ({ order, onReorder }) => {
  const [expanded, setExpanded] = useState(false);
  const { meta, items, fulfillment, payment, customer, discounts = [] } = order;

  return (
    <Paper sx={{ mb: 4, p: 3 }}>
      <OrderHeader orderId={meta.orderId} createdAt={meta.createdAt} />

      <Divider sx={{ my: 2 }} />

      <OrderItemList items={items} />

      <Divider sx={{ my: 2 }} />

      <OrderSummary payment={payment} discounts={discounts} />

      <OrderDetails
        expanded={expanded}
        fulfillment={fulfillment}
        customer={customer}
        payment={payment}
        meta={meta}
      />

      <Divider sx={{ my: 3 }} />

      <OrderFooter
        expanded={expanded}
        setExpanded={setExpanded}
        onReorder={() => onReorder(order)}
        stripeReceiptUrl={payment.stripeReceiptUrl}
      />
    </Paper>
  );
};

export default OrderCard;
